<template>
  <div v-if="showMultiAcs">
    <DynamicControls
      :configFields="fieldsGroup1.configFields"
      :configValues="fieldsGroup1.configValues"
      :handleValueChange="dataKeyChanged"
    />

    <ApplicationDetailsMultiAcs />

    <DynamicControls
      :configFields="fieldsGroup2.configFields"
      :configValues="fieldsGroup2.configValues"
      :handleValueChange="dataKeyChanged"
    />
  </div>

  <DynamicControls
    v-else
    :configFields="fields.configFields"
    :configValues="fields.configValues"
    :handleValueChange="dataKeyChanged"
  />
</template>

<script>
import { cloneDeep, omit } from 'lodash';

import ApplicationDetailsMultiAcs from 'client/applications/ApplicationDetailsMultiAcs.vue';
import ApplicationDynamicControlsMixin from 'client/applications/mixins/ApplicationDynamicControlsMixin';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';

const excludeFields = [
  'constantAttributes',
  'databaseAttributes',
  'groupsAttributeName',
  'includeGroups',
];
const getEmptyFields = () => ({ configFields: [], configValues: [] });

export default {
  name: 'ApplicationDetailsMainDynamicControls',

  components: {
    ApplicationDetailsMultiAcs,
  },

  mixins: [
    ApplicationDynamicControlsMixin,
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    enableMultiAcs: Boolean,
  },

  computed: {
    acsUrlIndex() {
      return this.fields.configFields.findIndex(({ name }) => name === 'acsUrl');
    },

    fields() {
      // Clone config, omit 'secondary' attributes
      // Parse config into entries
      // lodash.omit creates a shallow copy so deep clone to avoid state mutation
      return Object.entries(cloneDeep(omit(this.item.config, excludeFields)))
        .sort((a, b) => a[1].position - b[1].position) // Sort by position ascending
        .reduce((acc, entry) => {
          const [, field] = entry;

          // ignore invisible fields
          if (field.visible || field.visible === undefined) {
            // Parsed values pushed to configFields and configValues here
            // This is a good candidate for a refactor since it's not clear
            // what this method does without looking at a mixin
            // The naming convention `configFields` and `configValues` is expected
            // by this util method
            this.reduceLegacyDynamicControlConfig({
              current: entry,
              previous: acc,
            });
          }

          return acc;
        }, getEmptyFields());
    },

    fieldsGroup1() {
      return this.enableMultiAcs
        ? {
          configFields: this.fields.configFields.slice(0, this.acsUrlIndex) || [],
          configValues: this.fields.configValues.slice(0, this.acsUrlIndex) || [],
        }
        : getEmptyFields();
    },

    fieldsGroup2() {
      return this.enableMultiAcs
        ? {
          configFields: this.fields.configFields.slice(this.acsUrlIndex + 1) || [],
          configValues: this.fields.configValues.slice(this.acsUrlIndex + 1) || [],
        }
        : getEmptyFields();
    },

    showMultiAcs() {
      // There are 8 SAML templates that don't support ACS URL
      // For those we need to display the default view i.e. not include acsUrl
      return this.enableMultiAcs && this.acsUrlIndex > -1;
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },
};
</script>
